export default __webpack_public_path__ + "static/media/graz3_light.225be81c.png";